import { FC } from 'react'
import { BooleanInput, Edit, NumberInput, SimpleForm, useRecordContext, useTranslate } from 'react-admin'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import InputAdornment from '@mui/material/InputAdornment'
import { OrganizationWorkflowLinkOut } from '../../types/apiRequests'
import { LinkUserAccessSection } from '../../components'
import { themeColor } from '../../layout/theme/color'
import LinkAttachmentsSection from './LinkAttachmentsSection'
import LinkServerConfigsSection from './LinkServerConfigsSection'
import LinkVariablesSection from './LinkVariablesSection'

const LinkInfo: FC = () => {
  const record = useRecordContext<OrganizationWorkflowLinkOut>()
  const translate = useTranslate()
  if (!record) return null

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" sx={{ color: themeColor.slate60 }}>
        {translate('resources.organization_workflow_link.linkLabel', {
          org: record.organization_display_name,
          workflow: record.workflow_display_name,
        })}
      </Typography>
    </Box>
  )
}

const LinkEditForm: FC = () => {
  const translate = useTranslate()
  return (
    <SimpleForm>
      <LinkInfo />
      <BooleanInput source="enabled" />
      <NumberInput
        source="cost_per_workflow_execution"
        label="resources.organization_workflow_link.costPerWorkflowExecution"
        helperText={translate('resources.organization_workflow_link.costPerWorkflowExecutionHelp')}
        min={0}
        step={0.0001}
        fullWidth
        InputProps={{ startAdornment: <InputAdornment position="start">€</InputAdornment> }}
      />
      <LinkVariablesSection />
      <LinkServerConfigsSection />
      <LinkAttachmentsSection />
      <LinkUserAccessSection resource="organization_workflow_link" />
    </SimpleForm>
  )
}

const OrganizationWorkflowLinkEdit: FC = () => (
  <Edit mutationMode="pessimistic" redirect={false}>
    <LinkEditForm />
  </Edit>
)

export default OrganizationWorkflowLinkEdit
